export const paymentMethods = [
  'credit_card',
  'pix',
  'bank_slip',
  'wallet_picpay',
  'wallet_google_pay',
  'wallet_apple_pay',
  'paypal',
  'venmo',
  'paze',
];

export const paymentStatus = [
  'awaiting_payment',
  'paid',
  'refunded',
  'not_authorized',
];

export enum IntegrationEvent {
  INITIATE_CHECKOUT = 'initiate_checkout',
  CHARGEBACK = 'chargeback',
}

// Status de processamento para pedidos físicos
export const processingStatus = [
  'pending_order',
  'processing_order',
  'shipped',
  'in_transit',
  'out_for_delivery',
  'delivered',
  'delivery_failed',
  'cancelled_order',
  'returned',
] as const;
